import React from 'react';

/**
 * Het portret van een persona, of een terugval als er geen is.
 *
 * Stond eerder in drie bestanden: als personaBeeld() in het leerlingscherm en
 * als losse <img> in de twee beheerschermen. De regel is overal dezelfde: de
 * server levert het beeld op /student/portret/<bestandsnaam>, zonder
 * inlogcontrole, en een persona zonder portret krijgt wat het scherm als
 * terugval meegeeft (een icoon, een emoji, of niets).
 */
export function portretUrl(apiUrl, naam) {
  return apiUrl + '/student/portret/' + naam;
}

export function Portret({ apiUrl, naam, grootte, terugval = null, stijl = {} }) {
  if (!naam) return terugval;
  return (
    <img
      src={portretUrl(apiUrl, naam)}
      alt=""
      style={{ width: grootte, height: grootte, borderRadius: '50%', objectFit: 'cover', ...stijl }}
    />
  );
}
